import { render, staticRenderFns } from "./ButtonPrimaryForward.vue?vue&type=template&id=f00cc71e&scoped=true"
import script from "./ButtonPrimaryForward.vue?vue&type=script&lang=js"
export * from "./ButtonPrimaryForward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00cc71e",
  null
  
)

export default component.exports